import { Template } from "../../templates/shared/template.model";
import { QuestionNumberType } from "./questionnumbertype.model";

export class Target {
  public accessExpression: string;
  public active: boolean = true;
  public afterConfigDatasetExpression: string;
  public afterImportExpression: string;
  public beforeImportExpression: string;
  public calculateDefaultHidden: boolean = true;
  public cardTemplate: Template;
  public cardTemplateID: number;
  public cardTemplateDesignerID: string;
  public completedDate: Date;
  public createdBy: string;
  public createdDate: Date;
  public dataApiBatchUrl: string;
  public dataApiPost: boolean = false;
  public dataApiUrl: string;
  public defaultNameStyleID: number;
  public defaultValueStyleID: number;
  public description: string;
  public designerID: string;
  public disableDefaultNavButtons: boolean = false;
  public disableOnSave: boolean = false;
  public enhancedExpressionSecurity: boolean = true;
  public externalSearchable: boolean = false;
  public externalVisible: boolean = false;
  public footerTemplateID: number;
  public footerTemplateOwnerVar: string;
  public footerHtml: string;
  public fromDataApi: boolean = false;
  public global: boolean = false;
  public headerTemplateID: number;
  public headerTemplateOwnerVar: string;
  public headerHtml: string;
  public id: number;
  public iterateExpression: string;
  public iterateOnCardOpen: boolean = false;
  public iterative: boolean = false;
  public locked: boolean = false;
  public maxValueDate: Date;
  public name: string;
  public notes: string;
  public notifyOnSave: boolean = false;
  public ownerID: number;
  public ownerDesignerID: string;
  public percentComplete: number = 0;
  public progressExpression: string;
  public published: boolean = false;
  public questionNumberType: QuestionNumberType;
  public questionNumberTypeID: number;
  public readOnly: boolean = false;
  public rerenderByDisplayParent: boolean = true;
  public rerenderAllIndices: boolean = false;
  public selected: boolean;
  public seq: number = 0;
  public showCompletedBy: boolean = false;
  public showIterateButton: boolean = false;
  public showProgress: boolean = false;
  public showSummaryDownload: boolean = false;
  public sqlTypeName: string;
  public sqlTypeSchema: string;
  public submitExpression: string;
  public submittable: boolean = false;
  public subTargetROTracksTarget: boolean = false;
  public subTargetsReadOnly: boolean;
  public summaryTemplateID: number;
  public summaryTemplateDesignerID: string;
  public targetedElementBinding: boolean = true;
  public universal: boolean = false;
  public validationExpression: string;
  public wokflowInitialStateID: number;
  public wokflowInitialStateDesignerID: string;
  public workflowProcessID: number;
  public workflowProcessDesignerID: string;
}
